import { __assign } from "tslib";
import { ToggleButton } from './toggle-button';
import { renderAndMountComponent } from '@wix/answers-lib';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
import * as React from 'react';
export var createToggleButtonDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.toggle-button', ToggleButton.name);
    return {
        click: function () { return baseDriver.click(); },
        getText: function () { return baseDriver.getText(); },
        isChecked: function () { return baseDriver.elem.classList.contains('checked'); }
    };
};
export var createToggleButton = function (props, children) {
    var element = renderAndMountComponent(React.createElement(ToggleButton, __assign({}, props), children));
    return createToggleButtonDriver(element);
};
//# sourceMappingURL=toggle-button.driver.js.map